"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _75F3RDBEcjs = require('./75F3RDBE.cjs');


var _WMTGHDLEcjs = require('./WMTGHDLE.cjs');


var _4TRESXTOcjs = require('./4TRESXTO.cjs');

// src/hovercard/hovercard-store.ts
function createHovercardStore(props = {}) {
  var _a;
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  const popover = _75F3RDBEcjs.createPopoverStore.call(void 0, {
    ...props,
    placement: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.placement,
      syncState == null ? void 0 : syncState.placement,
      "bottom"
    )
  });
  const timeout = _4TRESXTOcjs.defaultValue.call(void 0, props.timeout, syncState == null ? void 0 : syncState.timeout, 500);
  const initialState = {
    ...popover.getState(),
    timeout,
    showTimeout: _4TRESXTOcjs.defaultValue.call(void 0, props.showTimeout, syncState == null ? void 0 : syncState.showTimeout),
    hideTimeout: _4TRESXTOcjs.defaultValue.call(void 0, props.hideTimeout, syncState == null ? void 0 : syncState.hideTimeout),
    autoFocusOnShow: _4TRESXTOcjs.defaultValue.call(void 0, syncState == null ? void 0 : syncState.autoFocusOnShow, false)
  };
  const hovercard = _WMTGHDLEcjs.createStore.call(void 0, initialState, popover, props.store);
  return {
    ...popover,
    ...hovercard,
    setAutoFocusOnShow: (value) => hovercard.setState("autoFocusOnShow", value)
  };
}



exports.createHovercardStore = createHovercardStore;
